import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navItems } from '../../data/site';
import { ButtonLink } from '../ui/Button';
import { Container } from '../ui/Container';
import { Logo } from '../ui/Logo';

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
      <Container className="flex min-h-20 items-center justify-between gap-6">
        <Link to="/" aria-label="Spitertech Solutions LLP home">
          <Logo theme="dark" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary navigation">
          {navItems.map((item) => (
            <NavLink
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm font-semibold transition ${
                  isActive ? 'bg-brand-50 text-brand-900' : 'text-muted hover:bg-slate-50 hover:text-ink'
                }`
              }
              key={item.href}
              to={item.href}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <ButtonLink to="/contact">Start a Project</ButtonLink>
        </div>

        <button
          aria-expanded={open}
          aria-label="Toggle navigation menu"
          className="inline-flex h-11 w-11 items-center justify-center rounded-md text-brand-900 hover:bg-brand-50 lg:hidden"
          onClick={() => setOpen((value) => !value)}
          type="button"
        >
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </Container>

      {open ? (
        <div className="border-t border-slate-200 bg-white lg:hidden">
          <Container className="grid gap-2 py-4">
            {navItems.map((item) => (
              <NavLink
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm font-semibold ${
                    isActive ? 'bg-brand-50 text-brand-900' : 'text-muted hover:bg-slate-50'
                  }`
                }
                key={item.href}
                onClick={() => setOpen(false)}
                to={item.href}
              >
                {item.label}
              </NavLink>
            ))}
            <ButtonLink className="mt-2" onClick={() => setOpen(false)} to="/contact">
              Start a Project
            </ButtonLink>
          </Container>
        </div>
      ) : null}
    </header>
  );
}
